<input type="text" value="" class="heightzero" #clipboardInput>
<div class="tabcontainer">
  <div class="searchBlock">
    <div class="searchSection">
      <i class="icon-search"></i>
      <div class="searchtxt">
        <input #listingInput id="searchInputBox" class="search-components textBox" type="text" placeholder="Insert search query and press Enter to search..." [formControl]='searchQuery'
          [(ngModel)]="str" (keydown)="onKeydown($event, listingInput)" (focus)="searchFocus = true"
          (focusout)="searchFocus = false" autofocus />
      </div>
    </div>
    <div class="filterSection spImg" style="
    display: block;">
      <i class="icon-filter"></i>
      <div class="fliterBlock">
        <ul class="filterOption">
          <ng-container *ngIf="filterList && facets">
            <ng-container *ngFor="let filter of filterList;let i = index">
              <li [class]="(i <= 3) ? 'togfilt block' : (i > 3 && showMore) ? 'togfilt block' : 'togfilt none'">
                <filter [filterType]="filter.type" [displayName]="filter.name"
                  [data]="getFilterData(filter.facet_name_meta)" [facetName]="filter.facet_name"
                  [facetNameMeta]="filter.facet_name_meta" [isDataKeyValuePair]="filter.isDataKeyValuePair"
                  [filterId]="filter.filter_id" (filterSelect)="urlUpdate($event)"></filter>
              </li>
              <span #moreButtonEl tabindex="0"
                [class]="(checkFocusInside(moreButtonEl) ? (showMore ? 'morefilterdrop spImg less focused' : 'morefilterdrop spImg more focused') : (showMore ? 'morefilterdrop spImg less' : 'morefilterdrop spImg more'))"
                (click)="(showMore = !showMore)"
                *ngIf="(filterList.length > 4 ) && i === 3">{{(showMore) ? 'less' : 'more'}}</span>
            </ng-container>
          </ng-container>
        </ul>
      </div>
    </div>
    <div class="closebg"></div>
  </div>




  <div class="contentList">
    <ng-template #loading>
      <div style="text-align: center; display: inline-block; width: 100%;">
        <ng-container *ngIf="callFail">
          <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">
            Sorry, Server Error
          </div>
        </ng-container>
        <ng-container *ngIf="!callFail">
          <div class="imagepreloader">
            <div class="a" style="--n: 5;">
              <div class="dot dot1" style="--i: 0;"></div>
              <div class="dot dot2" style="--i: 1;"></div>
              <div class="dot dot3" style="--i: 2;"></div>
              <div class="dot dot4" style="--i: 3;"></div>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-template>

    <ng-template #nores>
      <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">No Data</div>
    </ng-template>
    <ng-container *ngIf="noresults == false;then listData else nores"></ng-container>
    <ng-template #listData>
      <!-- vb -->
      <ng-container>
        <ng-container *ngIf="videoList.length > 0;else loading"></ng-container>
        <div class="listgrid videoslist" id="textNoData">
          <!-- <div class="videoslistBlock"> -->
            <div class="search-results videoslistBlock" id="imagesListOnInternalTabBlockListView" infiniteScroll [infiniteScrollDistance]="5" [infiniteScrollThrottle]="80"
                    [scrollWindow]="false" (scrolled)="fetchMore()" >
              <ng-container *ngFor="let smallList of multiList">
                <ul class="videolist">

                  <li *ngFor="let video of smallList" (deferLoad)="video.show = true">
                    <div class="imageblock" #listData2>
                      <div class="image" (mouseenter)="isSelectionOn ? onHovering($event) : false">
                        <ng-container
                          *ngIf="video.images && video.images.img_720 && video.show; then srcimage else nosrcimage">
                        </ng-container>
                        <ng-template #srcimage>
                          <div class="imagecontain"><img [src]="video.images.img_720" alt="">
                            <span class="hover">
                                <button class="blue" (click)="sendVideoToParent(video)">Use
                                  Video</button>
                              </span>
                          </div>
                        </ng-template>
                        <ng-template #nosrcimage>
                          <div class="imagecontain"><img src="../../../assets/images/404.jpg" alt="">
                            <span class="hover">
                                <button class="blue" (click)="sendVideoToParent(video)">Use
                                  Video</button>
                              </span>
                          </div>
                        </ng-template>
                      </div>
                      <div class="imageInfo">
                        <div class="heading">{{video.name}}</div>
                      </div>
                    </div>
                  </li>


                </ul>
              </ng-container>
            </div>
          <!-- </div> -->
        </div>
      </ng-container>
    </ng-template>
  </div>

  <ng-container *ngIf="showLoader && videoList.length > 0">
    <div style="text-align: center; display: inline-block; width: 100%;">
      <ng-container>
        <div class="imagepreloader">
          <div class="a" style="--n: 5;">
            <div class="dot dot1" style="--i: 0;"></div>
            <div class="dot dot2" style="--i: 1;"></div>
            <div class="dot dot3" style="--i: 2;"></div>
            <div class="dot dot4" style="--i: 3;"></div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>





  <div class="footerPagination">
      <div class="recordList borderNone" id="showingResult">
        Showing {{totalRecords}} results</div>
  </div>
</div>